export default __webpack_public_path__ + "static/media/Image26.ce362b0a.png";